export default __webpack_public_path__ + "static/media/QUEROVET - LOGO AZUL.0d135441.png";